import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  getSourceContextCookie,
  writeSourceContextCookie,
} from '../services/cookieService/cookieService';

export const SEARCH_PARAM_SOURCE = 'utm_source';

const useSourceContext = () => {
  const [searchParams] = useSearchParams();
  const [querySourceContext] = useState<string>(
    searchParams.get(SEARCH_PARAM_SOURCE) as string,
  );
  const [cookieSourceContext] = useState<string | null>(
    getSourceContextCookie(),
  );

  useEffect(() => {
    if (!querySourceContext) return;

    writeSourceContextCookie(querySourceContext);
  }, [querySourceContext]);

  return querySourceContext ?? cookieSourceContext;
};

export default useSourceContext;
